import React from 'react'
import {
  List
} from 'camino-react'

const BillingDetailsFormDescription = () => (
  <p>
    There are different types of billing details for work types, these include:
    <List borders={false}>
      <li>
        <h3>
          Round
        </h3>
        <p>
          If the duration is less than the
          {' '}
          <strong>
            Minimum Time
          </strong>
          , then the duration will be rounded to the
          {' '}
          <strong>
            Minimum Time
          </strong>
          .
        </p>
        <p>
          If the duration is more than the
          {' '}
          <strong>
            Minimum Time
          </strong>
          , then the duration will be rounded to the
          {' '}
          <strong>
            Round By.
          </strong>
        </p>
      </li>
      <li>
        <h3>
          Boundary
        </h3>
        <p>
          If the duration is less than the
          {' '}
          <strong>
            Minimum Time
          </strong>
          , then the duration will be set to 0.
        </p>
        <p>
          If the duration is more than the
          {' '}
          <strong>
            Minimum Time
          </strong>
          , then the duration will be rounded to the
          {' '}
          <strong>
            Round By
          </strong>
          .
        </p>
      </li>
      <li>
        <h3>
          Fixed
        </h3>
        <p>
          The duration will be set to the
          {' '}
          <strong>
            Minimum Time
          </strong>
        </p>
      </li>
    </List>
  </p>
)

export default BillingDetailsFormDescription
